
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <div id="OperationsList" v-if="$route.name === 'WorksLotsList'">
    
    <div class="giga-content_container">
      <div class="giga-actions">
        <div class="giga-actions_left">
          <ul class="giga-actions_row">
            <li class="giga-action_item">
              <div class="giga-action_search">
                <input type="search" name="" id="" placeholder="Recherche" v-model="search" @input="lotSearch()"/>
                <button class="giga-search_button">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.7448 22.6899L17.772 16.7171C21.2724 12.4326 20.6421 6.12211 16.3576 2.62172C12.0768 -0.878671 5.76261 -0.248376 2.26222 4.03613C-1.23817 8.32064 -0.607873 14.6311 3.67663 18.1315C7.36461 21.1479 12.6696 21.1479 16.3576 18.1315L22.3304 24.1043C22.7431 24.472 23.3771 24.4382 23.7448 24.0255C24.0862 23.6466 24.0862 23.0726 23.7448 22.6899ZM10.0321 18.3941C5.60879 18.3941 2.02586 14.8149 2.02211 10.3916C2.02211 5.96829 5.60129 2.38536 10.0246 2.38161C14.4479 2.38161 18.0309 5.96078 18.0346 10.3841C18.0346 10.3841 18.0346 10.3879 18.0346 10.3916C18.0271 14.8074 14.4479 18.3866 10.0321 18.3941Z"
                      fill="#8C9DAB"
                    />
                  </svg>
                </button>
              </div>
              <!-- <div></div> -->
            </li>
            <filter-modal
              :query-config="queryConfig"
              v-on:onFilter="applyFilter($event)"
              v-on:onReloadData="applyFilter($event)"
              :headerTitle="'filtrer_operation'"
              :currentFilter="currentFilter"
            ></filter-modal>
          </ul>
        </div>
      </div>

      <page-loader v-if="loading"></page-loader>

      <!-- <div
          v-if="getLoading"
          class="giga-pre_loading"
      >
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div> -->
        <div class="giga-operations_list" v-else>
          <div class="row">
            <div
              v-for="(lot, index) in getLots.content"
              :key="index"
              class="col-xl-4 col-lg-6"
            >
              <div class="giga-flexible_card">
                <div class="giga-flexible_card_header">
                  <h3 class="giga-flexible_card_title">Lot#{{ lot.id }}</h3>
                </div>
                <div class="giga-flexible_card_body">
                  <div class="giga-flexible_card_details">
                    <ul class="giga-simulation_card_details">
                      <li class="giga-flexible_card_status">
                        <label>Nombre d’opérations</label>
                        <span>{{ lot.totalOperations }}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="giga-flexible_card_actions">
                    <button
                      class="work-card_details_button"
                      @click="onLotSelected(lot.id)"
                    >
                      Détails
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
    <router-view v-else/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {debounce} from "lodash"
import PageLoader from "../../components/static/pageLoader.vue";
import FilterModal from "@/components/static/FilterModal";
import {queryConstant} from "@/shared/queryConstant";

export default {
  components: { FilterModal, PageLoader },
  name: "OperationsList",
  data() {
    const _pageSize_10 = 10;
    const _pageSize_25 = 25;
    const _pageSize_50 = 50;
    return {
      scrollBarSettings: {
        scrollXMarginOffset: 50,
      },
      perPage: 10,
      currentPage: 1,
      length: [_pageSize_10, _pageSize_25, _pageSize_50],
      rowOpened: [],
      sortBy: null,
      sortDir: "asc",
      customFilter: queryConstant.setDefaultCustomFilter(),
      currentFilter: {},
      queryConfig: queryConstant.LOT_CONFIG,
      search: '',
      fetchData: () => {},
    };
  },
  mounted() {
    this.getWorkLotsAction({
      id: parseInt(this.$route.params["id"], 10),
      currentPage: this.currentPage,
      perPage: this.perPage,
      customFilter: this.customFilter,
    });
    this.fetchData = debounce(this.getWorkLots, 500);
  },
  computed: {
    ...mapGetters("work", ["getLots"]),
    ...mapGetters("loader", ["getLoading"]),
    ...mapGetters("loader", { downloadLoader: "getDownloadOperations" }),
    rows() {
      return this.getLots.totalElements;
    },
  },
  methods: {
    ...mapActions("work", ["getWorkLotsAction"]),
    getWorkLots() {
      this.getWorkLotsAction({
        id: parseInt(this.$route.params["id"], 10),
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
        customFilter: this.customFilter,
        search: this.search
      });
    },
    // changePerPage(perPage) {
    //   this.currentPage = 1;
    //   this.perPage = perPage;
    //   this.getWorkLots();
    // },
    // changeCurrentPage(currentPage) {
    //   this.currentPage = currentPage;
    //   this.getWorkLots();
    // },
    // rowToggle(id) {
    //   const index = this.rowOpened.indexOf(id);
    //   if (index > -1) {
    //     this.rowOpened.splice(index, 1);
    //   } else {
    //     this.rowOpened.push(id);
    //   }
    // },
    // rowOpenAll() {
    //   if (this.getLots.content && this.getLots.content.length) {
    //     this.getLots.content.forEach((lot) => {
    //       this.rowOpened.push(lot.id);
    //     });
    //   }
    // },
    // rowCloseAll() {
    //   this.rowOpened = [];
    // },
    // sortTable(name) {
    //   if (name === this.sortBy) {
    //     if (this.sortDir === "asc") {
    //       this.sortDir = "desc";
    //     } else {
    //       this.sortDir = "asc";
    //     }
    //   }
    //   this.sortBy = name;
    //   this.getWorkLots();
    // },
    // onRowSelected(idOperation) {
    //   this.$router.push({
    //     name: "WorksOperation",
    //     params: {
    //       id: parseInt(this.$route.params["id"], 10),
    //       idOperation: idOperation,
    //     },
    //   });
    // },
    onLotSelected(idLot) {
      this.$router.push({
        name: "WorksLotOperations",
        params: {
          id: parseInt(this.$route.params["id"], 10),
          idLot: idLot,
        },
      });
    },
    applyFilter(filter) {
      this.customFilter = filter.custom;
      this.currentFilter = filter.filters;
      this.getWorkLotsAction({
        id: parseInt(this.$route.params["id"], 10),
        currentPage: 1,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
        customFilter: this.customFilter,
      });
    },
    lotSearch() {
      this.fetchData();
    }
  },
  watch: {
    getLots(newContent) {
      if (newContent && newContent.content) {
        this.rowOpenAll();
      }
    },
  },
};
</script>
<style lang='scss'>
.view-area-table {
  position: relative;
  min-height: 350px;
  height: calc(100vh - 540px);
}
</style>
